<template>
  <div class="metric-column" data-testid="metric-column">
    <Typography variant="subtitle-2" class="metric-column__type">{{ typeLabel }}</Typography>
    <div class="metric-column__detail">
      <Typography v-if="visibilityLabel" variant="body-2">{{ visibilityLabel }}</Typography>
    </div>
    <div class="metric-column__actions">
      <Button icon small data-testid="edit-metric" @click="$emit('edit')">
        <Icon icon="mdi-pencil" color="darkGrey" small />
      </Button>
      <Button icon small data-testid="delete-metric" @click="$emit('delete')">
        <Icon icon="mdi-delete" color="darkGrey" small />
      </Button>
    </div>
  </div>
</template>

<script>
import Typography from "@/components/generic/Typography.vue";
import Button from "@/components/generic/Button.vue";
import Icon from "@/components/generic/Icon.vue";
import { metricComponentLabel, visibilityAttributeLabel } from "./AddMetricSideSheet/metricOptions";

export default {
  name: "MetricColumn",
  components: { Typography, Button, Icon },
  props: {
    // Null for an empty slot, which keeps the placeholder copy until the
    // unconfigured-slot design lands (ADO 189164).
    column: { type: Object, default: null },
  },
  emits: ["edit", "delete"],
  computed: {
    typeLabel() {
      return this.column ? metricComponentLabel(this.column.componentType) : "Big Number";
    },
    visibilityLabel() {
      if (!this.column) return "Visibility: Metric Name";
      const attribute = this.column.visibilityMetricAttribute;
      return attribute ? `Visibility: ${visibilityAttributeLabel(attribute)}` : "";
    },
  },
};
</script>

<style scoped>
.metric-column {
  display: flex;
  flex: 1 1 0;
  min-width: 0;
  align-items: center;
  gap: 16px;
  padding: 10px 8px 10px 16px;
  border: 2px solid var(--v-grey-base);
  border-radius: 4px;
  background: white;
}

.metric-column__type {
  flex-shrink: 0;
}

/* Always present so the actions stay right-aligned on a column with no
   visibility condition. */
.metric-column__detail {
  flex: 1 1 0;
  min-width: 0;
}

.metric-column__actions {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  gap: 4px;
}
</style>
